import { ChangeDetectionStrategy, Component, computed, contentChild, inject, input } from '@angular/core'
import { Router } from '@angular/router'
import { NgTemplateOutlet } from '@angular/common'
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms'
import { TableModule } from 'primeng/table'
import { InputText } from 'primeng/inputtext'
import { CertificateBaseComponent } from '@features/certificate/components/certificate-base/certificate-base.component'
import { AlbertInputWrapper } from '@features/certificate/components/certificate-input-wrapper/albert-input-wrapper'
import { CertificateHolderRow } from '@features/certificate/utils/certificate-holder-search.util'
import {
  AddressDisplayActionsDirective,
  AddressSearchActionsDirective,
  HolderDisplayActionsDirective,
  HolderSearchActionsDirective
} from '@features/certificate/components/certificate-holder-entity-manager/certificate-holder-row-action.directive'
import { Tooltip } from 'primeng/tooltip'
import { ButtonDirective } from 'primeng/button'
import { SIDEBAR_ROUTES } from '@app/layout/sidebar/models/sidebar.constants'

export type CertificateHolderSearchForm = FormGroup<{ value: FormControl<string | null> }>

@Component({
  selector: 'albert-certificate-holder-entity-manager',
  imports: [
    NgTemplateOutlet,
    ReactiveFormsModule,
    TableModule,
    AlbertInputWrapper,
    InputText,
    Tooltip,
    ButtonDirective
  ],
  templateUrl: './certificate-holder-entity-manager.component.html',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CertificateHolderEntityManagerComponent extends CertificateBaseComponent {
  public readonly groupedRows = input.required<CertificateHolderRow[]>()
  public readonly searchResultRows = input.required<CertificateHolderRow[]>()
  public readonly searchResultRowsByHolder = computed(() => this.searchResultRows().filter(row => row.type === this.certificateHolderRowType.HOLDER))
  public readonly emptyMessage = input.required<string>()
  public readonly searchTooltip = input.required<string>()
  public readonly searchForm = input.required<CertificateHolderSearchForm>()
  public readonly testId = input.required<string>()

  public readonly holderDisplayActions = contentChild(HolderDisplayActionsDirective)
  public readonly addressDisplayActions = contentChild(AddressDisplayActionsDirective)
  public readonly holderSearchActions = contentChild(HolderSearchActionsDirective)
  public readonly addressSearchActions = contentChild(AddressSearchActionsDirective)

  /** Mirrors the `permissionGuard('ALB_ALBERT_E_')` on the certificate-holder management routes. */
  public readonly canOpenCertificateHolder = this.permissionService.hasEditRights

  private readonly router = inject(Router)

  public openCertificateHolder(uuid: string): void {
    const url = this.router.serializeUrl(this.router.createUrlTree([SIDEBAR_ROUTES.CERTIFICATE_HOLDER_PATH, uuid]))
    window.open(url, '_blank')
  }
}
